import { elements } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import { handle } from './wrapper.js'

const handler = async (radio, wrapper, item) => {
  const inputs = all(`.${elements.new_field_input}`, wrapper)
  const itemInputs = all(`.${elements.new_field_input}`, item)

  for (const input of inputs) {
    input.removeAttribute('required')
  }

  for (const itemInput of itemInputs) {
    if (itemInput.type !== 'hidden') {
      itemInput.required = true
    }
  }
}

export default radio => {
  handle(radio, handler)
}
